import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import SmsReportCard from "../../admin/components/report/SmsReportCard";

const SmsReport = ({ token, distributor }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!distributor || !distributor.sms_report) {
            history.push('/distributor');
        }
    }, []);

    const handleToggle = () => {
        setToggled(!toggled);
    };

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <SmsReportCard
                        role="distributor"
                        token={token}
                        sms_credit={0}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(SmsReport);